import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSlider } from 'vuetify/lib/components/VSlider';
import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c(VRow, [_c(VCol, [_c(VSwitch, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$t('Dashboards.components.widgetTwinMapOptionsEditor.inputs.interactive.label'),
      "data-cy": "interactive-switch"
    },
    model: {
      value: _vm.interactive,
      callback: function ($$v) {
        _vm.interactive = $$v;
      },
      expression: "interactive"
    }
  })], 1)], 1), _c(VRow, [_c(VCol, [_c(VSwitch, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$t('Dashboards.components.widgetTwinMapOptionsEditor.inputs.zoomingEnabled.label'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "data-cy": "zoom-activate-switch"
    },
    model: {
      value: _vm.zoomingEnabled,
      callback: function ($$v) {
        _vm.zoomingEnabled = $$v;
      },
      expression: "zoomingEnabled"
    }
  })], 1)], 1), _c(VRow, [_c(VCol, [_c(VSlider, {
    attrs: {
      "step": "1",
      "label": _vm.$t('Dashboards.components.widgetTwinMapOptionsEditor.inputs.maxZoom.label'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "min": 0,
      "max": 15,
      "hide-details": "",
      "ticks": ""
    },
    model: {
      value: _vm.maxZoom,
      callback: function ($$v) {
        _vm.maxZoom = $$v;
      },
      expression: "maxZoom"
    }
  })], 1)], 1), _c(VRow, [_c(VCol, [_c(VSwitch, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$t('Dashboards.components.widgetTwinMapOptionsEditor.inputs.clusteringEnabled.label'),
      "data-cy": "clustering-switch"
    },
    model: {
      value: _vm.clusteringEnabled,
      callback: function ($$v) {
        _vm.clusteringEnabled = $$v;
      },
      expression: "clusteringEnabled"
    }
  })], 1)], 1), _vm.clusteringEnabled ? _c(VRow, [_c(VCol, [_c(VSlider, {
    attrs: {
      "step": "1",
      "label": _vm.$t('Dashboards.components.widgetTwinMapOptionsEditor.inputs.ClusterRadius.label'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "min": 0,
      "max": 150,
      "hide-details": "",
      "ticks": ""
    },
    model: {
      value: _vm.clusterRadius,
      callback: function ($$v) {
        _vm.clusterRadius = $$v;
      },
      expression: "clusterRadius"
    }
  })], 1)], 1) : _vm._e(), _c(VRow, [_c(VCol, [_c(VSwitch, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$t('Dashboards.components.widgetTwinMapOptionsEditor.inputs.hasPopup.label'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "data-cy": "popup-switch"
    },
    model: {
      value: _vm.hasPopup,
      callback: function ($$v) {
        _vm.hasPopup = $$v;
      },
      expression: "hasPopup"
    }
  })], 1)], 1), _vm.shapefilesEnabled ? _c(VRow, [_c(VCol, [_c('div', {
    staticClass: "position-relative"
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "loading": _vm.isUploading
    },
    on: {
      "click": _vm.openShapefile
    }
  }, [_c('span', {
    staticClass: "text-wrapper"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('Dashboards.components.widgetTwinMapOptionsEditor.buttons.uploadShapefile')) + "\n            "), _c(VChip, {
    staticClass: "beta-badge",
    attrs: {
      "x-small": "",
      "color": "warning",
      "label": ""
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('Dashboards.components.widgetTwinMapOptionsEditor.labels.beta')) + "\n            ")])], 1)])], 1)]), _c(VCol, [_c(VSelect, {
    attrs: {
      "loading": _vm.isFetchingTilesets,
      "items": _vm.tilesets,
      "item-text": "meta.name",
      "item-value": "value.tileSetId",
      "multiple": ""
    },
    model: {
      value: _vm.tilesetIds,
      callback: function ($$v) {
        _vm.tilesetIds = $$v;
      },
      expression: "tilesetIds"
    }
  })], 1)], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };